// extracted by css-extract-rspack-plugin
export default {"wrapper":"_71e268b0","crumb":"_8eae67a8","crumbLink":"_1121c588"};